import { Row, Separator, Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Lookup from './Lookup'
import { PageTitleContext } from './PageTitleContext'
import StatusOverlayAnchor from './StatusOverlayAnchor'

export default function SubHeader() {
  const { pageTitle } = React.useContext(PageTitleContext)
  const { t } = useTranslation()
  // The row that holds the universal search box, so the error/status overlay can open below it
  // instead of on top of it (DATA-12442).
  const searchRowRef = React.useRef(null)
  return (
    <>
      <Separator />
      <Row wrap ref={searchRowRef}>
        {!!pageTitle && (
          <Grid container columns="auto 1fr" alignX="center" growX gap="0" padding="0" margin="0">
            <Grid item>
              <div style={{ marginTop: '-0.5em', fontSize: '20px' }}>{t('app.title', 'Data Management Console')}</div>
            </Grid>
            <Grid item margin="0" padding="0">
              <h1 size="h5" growX style={{ marginTop: '-1em', fontWeight: 'bold' }}>
                {pageTitle}
              </h1>
            </Grid>
          </Grid>
        )}
        {!pageTitle && (
          <h1 size="h6" growX>
            {t('app.title', 'Data Management Console')}
          </h1>
        )}
        <Lookup />
      </Row>
      <StatusOverlayAnchor anchorRef={searchRowRef} />

      <Separator size="xs" />
    </>
  )
}
